/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, "count, plural, one {": NonNullable<unknown>, s: NonNullable<unknown> }} Knp_Lookup_Deleted_Terms_ToastInputs */



/**
* | output |
* | --- |
* | "Deleted {count} term{count, plural, one {} other {s}} successfully" |
*
* @param {Knp_Lookup_Deleted_Terms_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_deleted_terms_toast = /** @type {((inputs: Knp_Lookup_Deleted_Terms_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Deleted_Terms_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supprime ${i?.count} terme${i?.["count, plural, one {"]} other ${i?.s}} avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Term${i?.["count, plural, one {"]} other ${i?.s}} erfolgreich gelöscht`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Eliminato correttamente il termine ${i?.count}${i?.["count, plural, one {"]} other ${i?.s}}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Термин ${i?.count} успешно удален.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se eliminó correctamente el término ${i?.count} ${i?.["count, plural, one {"]} other ${i?.s}}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已成功删除 ${i?.count} 术语 ${i?.["count, plural, one {"]} other ${i?.s}}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 用語 ${i?.["count, plural, one {"]} other ${i?.s}} を正常に削除しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} पद${i?.["count, plural, one {"]} other ${i?.s}} सफलतापूर्वक हटा दिया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Termo __PH_0_ ...")
	return /** @type {LocalizedString} */ (`Deleted ${i?.count} term${i?.["count, plural, one {"]} other ${i?.s}} successfully`)
});